import { transformCloudinaryUrl } from 'shared/types/utils/cloudinary';
import cloudinaryMap from './cloudinary-map.json';

/**
 * Brand-refresh imagery lives in Cloudinary (Media Library folder www.viewrail/shop-components, random public IDs,
 * so URLs are looked up here rather than derived). Files not yet uploaded fall back to the copy in /public/brand-refresh.
 * The map is keyed by the /public filename; regenerate entries by pasting the Media Library URL for that file.
 */
const CLOUDINARY_URLS: Record<string, string> = cloudinaryMap;

export const LOCAL_BRAND_ASSET_PREFIX = '/brand-refresh/';

/** Resolve a brand-refresh asset by filename (e.g. `brandAsset('tile-samples.jpg')`) to its delivery URL. */
export function brandAsset(fileName: string): string {
  return CLOUDINARY_URLS[fileName] ?? `${LOCAL_BRAND_ASSET_PREFIX}${fileName}`;
}

/**
 * Resolve a brand-refresh asset and, when it's on Cloudinary, deliver it at `width` in auto format/quality.
 * For raw <img>/<picture> sources that bypass BrandImage.
 */
export function brandAssetAt(fileName: string, width: number): string {
  return transformCloudinaryUrl(brandAsset(fileName), { width }) ?? brandAsset(fileName);
}
